import React from 'react';
import { isMobile } from 'react-device-detect';
import { BiCheckCircle, BiSquare } from 'react-icons/bi';
import { IoWarning } from 'react-icons/io5';
import { formatDatePTBR } from '../../core/utils/timeConvert';

export const OsTermReport = React.forwardRef((props, ref) => {
  const {} = props;

  function abbreviateName(name) {
    const words = name.split(' ');

    if (words.length > 3) {
      return words
        .map((word, index) => {
          if (index === 0 || index === 1 || index === words.length - 1) {
            return word;
          }
          return word.charAt(0) + '.';
        })
        .join(' ');
    }

    return name;
  }

  const clientFound = props?.client.find(
    (client) =>
      client?.value === props?.values?.client ||
      client?.value === props?.values?.client?.value
  );

  const consultat = props.consultantState?.filter(
    (item) => item.id === props.values.id_consultant
  )[0];
  const financialCoresponsible = props?.client.find(
    (client) =>
      client?.value === props?.values?.financial_coresponsible ||
      client?.value === props?.values?.financial_coresponsible?.value
  );

  const haveItemValues = (itemValues) => {
    if (itemValues?.image) {
      return true;
    }
  };

  // Safe access to fixed_checklist with fallback to empty object
  const fixedChecklist = props?.values?.entry_checklist?.fixed_checklist || {};

  // Safe access to image_register with fallback to empty array
  const imageRegister = props?.values?.entry_checklist?.image_register || [];

  return (
    <div
      className={`os-term-report-os-print-container${
        isMobile ? ' mobile' : ''
      }${''}`}
      id="my-node"
      ref={ref}
    >
      <div
        id="print-padding-mobile"
        className="os-term-report-print-padding-mobile"
      >
        <div className="os-term-report-os-print-header">
          <div></div>
          <text className="os-term-report-header-title">LAUDO DE ENTRADA</text>
          <text className="os-term-report-header-code">
            N° {props.values.code}
          </text>
        </div>

        <div className="os-term-report-company-info-section">
          {(props.logoBase64 || props.company.logo) && (
            <img
              className="os-term-report-print-logo-os"
              src={
                props.logoBase64 ||
                `${process.env.REACT_APP_SUPABASE_URL}/storage/v1/object/public/${props.company.logo}`
              }
              alt="Logo da empresa"
              loading="eager"
              style={{
                width: '125px',
                maxWidth: '125px',
                maxHeight: '110px',
                objectFit: 'cover',
                padding: '5px',
              }}
              onError={(e) => {
                console.log('Erro ao carregar logo:', e);
                e.target.style.display = 'none';
              }}
            />
          )}
          <div className="os-term-report-company-details">
            <div className="os-term-report-company-main-info">
              <div className="os-term-report-company-text">
                <text>{props.company.name}</text>
              </div>
              <div className="os-term-report-company-text">
                <text>{props.company.cnpj}</text>
              </div>
              <div className="os-term-report-company-text">
                <text>
                  {props.company.street}, N°{props?.company?.number},{' '}
                  {props.company.neighborhood}, {props.company.city},{' '}
                  {props.company.state}
                  {props.company.complement ? ',' : ''}{' '}
                  {props.company.complement}
                  <br />
                  CEP: {props.company.cep}
                </text>
              </div>
              <div className="os-term-report-company-text">
                <text>Fone: {props.company.telephone}</text>
                <text>Whastapp: {props.company.cellphone}</text>
              </div>
            </div>

            <div className="os-term-report-company-meta-info">
              <text>
                Data abertura: {formatDatePTBR(props.values?.entry_date)}{' '}
                {props.values?.entry_hour}
              </text>
              <text className="os-term-report-delivery-date">
                Previsão entrega: {formatDatePTBR(props.values?.delivery_date)}{' '}
                {props.values?.delivery_hour}
              </text>
              <text>Consultor: {consultat?.label}</text>
              <text>
                Tipo de OS: <strong>{props?.values?.os_type?.label}</strong>
              </text>
            </div>
          </div>
        </div>
        {/* Area cliente, cpf/cnpj/ telefone */}

        <div className="os-term-report-client-section">
          <div className="os-term-report-client-info">
            <text className="os-term-report-client-name">
              <text>
                Nome:{' '}
                <strong className="os-term-report-client-name-value">
                  {clientFound?.label
                    ? abbreviateName(clientFound.label)
                    : '---'}
                </strong>
              </text>
              <text style={{ paddingLeft: 12 }}>
                CPF/CNPJ: {clientFound?.cpf || '---'}/
                {clientFound?.cnpj || '---'}
              </text>
              <text>WhatsApp: {clientFound?.cellphone || '---'}</text>
            </text>

            <text className="os-term-report-financial-responsible">
              <text>
                Responsável:{' '}
                <strong className="os-term-report-financial-responsible-value">
                  {financialCoresponsible?.label
                    ? abbreviateName(financialCoresponsible.label)
                    : '---'}
                </strong>
              </text>
              <text>
                CPF/CNPJ: {financialCoresponsible?.cpf || '---'}/
                {financialCoresponsible?.cnpj || '---'}
              </text>
              <text>
                WhatsApp: {financialCoresponsible?.cellphone || '---'}
              </text>
            </text>
          </div>
        </div>

        <div className="os-term-report-vehicle-section">
          <div className="os-term-report-vehicle-data-column">
            <div className="os-term-report-vehicle-header">DADOS VEÍCULO</div>
            <div className="os-term-report-vehicle-content">
              <div className="os-term-report-vehicle-info-row">
                <text>Marca/Modelo:</text>
                <text className="os-term-report-vehicle-value">
                  {props.values.Vehicle?.model || '---'}
                </text>
              </div>
              <div className="os-term-report-vehicle-info-row">
                <text>Kilometragem:</text>
                <text className="os-term-report-vehicle-value">
                  {props.values.mileage || '---'} km
                </text>
              </div>
            </div>
          </div>

          <div className="os-term-report-vehicle-details-grid">
            <div className="os-term-report-vehicle-detail-row">
              <text>Placa:</text>
              <text className="os-term-report-vehicle-detail-value">
                {props.values.Vehicle?.plate || '---'}
              </text>
            </div>
            <div className="os-term-report-vehicle-detail-row">
              <text>Motor:</text>
              <text className="os-term-report-vehicle-detail-value">
                {props.values.Vehicle?.engine || '---'}
              </text>
            </div>
            <div className="os-term-report-vehicle-detail-row">
              <text>Cor:</text>
              <text className="os-term-report-vehicle-detail-value">
                {props.values.Vehicle?.color || '---'}
              </text>
            </div>
            <div className="os-term-report-vehicle-detail-row">
              <text>Ano/Modelo:</text>
              <text className="os-term-report-vehicle-detail-value">
                {props.values.Vehicle?.year || '---'}/
                {props.values.Vehicle?.yearmodel || '---'}
              </text>
            </div>
            <div className="os-term-report-vehicle-detail-row">
              <text>Combustível:</text>
              <text className="os-term-report-vehicle-detail-value">
                {props.values.Vehicle?.fuel || '---'}
              </text>
            </div>
            <div className="os-term-report-vehicle-detail-row chassi">
              <text>Chassi:</text>
              <text className="os-term-report-vehicle-detail-value">
                {props.values.Vehicle?.chassi || '---'}
              </text>
            </div>
          </div>
        </div>

        {/* Area de serviços */}

        <div
          className="os-term-report-section-services"
          style={{ paddingBottom: '12px' }}
        >
          <div className="os-term-report-section-header-report">
            <text className="os-term-report-section-title">CHECKLIST</text>
          </div>

          <div
            className="os-term-report-images-grid"
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(2, 1fr)',
              gap: '4px',
              marginTop: '6px',
            }}
          >
            {Object.entries(fixedChecklist).map(([key, value], index) => (
              <React.Fragment key={value.id || index}>
                {haveItemValues(value) ? (
                  <div
                    className="os-term-report-image-item"
                    style={{
                      borderBottom: '1px solid #ddd',
                      padding: '4px 6px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px',
                    }}
                  >
                    {/* Ícone */}
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '14px',
                        flexShrink: 0,
                      }}
                    >
                      {value?.status === 1 || !value?.status ? (
                        <BiSquare
                          onClick={() => handleChangeStatus(value?.name)}
                          size={14}
                        />
                      ) : value?.status === 2 ? (
                        <BiCheckCircle
                          color="#52F035"
                          onClick={() => handleChangeStatus(value?.name)}
                          size={14}
                        />
                      ) : (
                        <IoWarning
                          color="#F24726"
                          onClick={() => handleChangeStatus(value?.name)}
                          size={14}
                        />
                      )}
                    </div>

                    {/* Nome */}
                    <text
                      style={{
                        fontSize: '9px',
                        minWidth: '60px',
                        flexShrink: 0,
                      }}
                    >
                      {key}
                    </text>

                    {/* Imagem */}
                    {value.image && (
                      <img
                        src={`${process.env.REACT_APP_SUPABASE_URL}/storage/v1/object/public/${value.image}`}
                        alt={`Registro ${index + 1}`}
                        style={{
                          width: '40px',
                          height: '40px',
                          objectFit: 'cover',
                          border: '1px solid #ddd',
                          flexShrink: 0,
                        }}
                      />
                    )}

                    {/* Informações condensadas */}
                    {(value.piece || value.description || value.observation) && (
                      <div style={{ fontSize: '8px', color: '#333', flex: 1 }}>
                        {value.piece && (
                          <div>
                            <strong>P:</strong>{' '}
                            {typeof value.piece === 'object' &&
                            value.piece !== null
                              ? value.piece.label ||
                                String(value.piece.value || '')
                              : String(value.piece || '')}
                          </div>
                        )}
                        {value.description && (
                          <div>
                            <strong>D:</strong>{' '}
                            {typeof value.description === 'object' &&
                            value.description !== null
                              ? value.description.label ||
                                String(value.description.value || '')
                              : String(value.description || '')}
                          </div>
                        )}
                        {value.observation &&
                          typeof value.observation === 'string' && (
                            <div>
                              <strong>Obs:</strong> {value.observation}
                            </div>
                          )}
                      </div>
                    )}
                  </div>
                ) : (
                  <div
                    className="os-term-report-image-item"
                    style={{
                      borderBottom: '1px solid #ddd',
                      padding: '4px 6px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px',
                    }}
                  >
                    {/* Ícone */}
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '14px',
                        flexShrink: 0,
                      }}
                    >
                      {value?.status === 1 || !value?.status ? (
                        <BiSquare
                          onClick={() => handleChangeStatus(value?.name)}
                          size={14}
                        />
                      ) : value?.status === 2 ? (
                        <BiCheckCircle
                          color="#52F035"
                          onClick={() => handleChangeStatus(value?.name)}
                          size={14}
                        />
                      ) : (
                        <IoWarning
                          color="#F24726"
                          onClick={() => handleChangeStatus(value?.name)}
                          size={14}
                        />
                      )}
                    </div>

                    {/* Nome */}
                    <text style={{ fontSize: '9px' }}>{key}</text>
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>

        <div
          className="os-term-report-section-services"
          style={{ paddingBottom: '16px' }}
        >
          <div className="os-term-report-section-header-report">
            <text className="os-term-report-section-title">
              REGISTRO POR IMAGEM
            </text>
          </div>

          <div
            className="os-term-report-images-grid"
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '15px',
              marginBottom: '10px',
            }}
          >
            {imageRegister.map((imageItem, index) => (
              <div
                key={imageItem.id || index}
                className="os-term-report-image-item"
                style={{
                  border: '1px solid #ccc',
                  padding: '8px',
                  backgroundColor: '#f9f9f9',
                  borderRadius: '4px',
                }}
              >
                {/* Imagem */}
                {imageItem.image && (
                  <img
                    src={`${process.env.REACT_APP_SUPABASE_URL}/storage/v1/object/public/${imageItem.image}`}
                    alt={`Registro ${index + 1}`}
                    style={{
                      width: '100%',
                      height: '116px',
                      objectFit: 'cover',
                      border: '1px solid #ddd',
                      marginBottom: '8px',
                    }}
                  />
                )}

                {/* Informações */}
                <div style={{ fontSize: '10px', color: 'black' }}>
                  {imageItem.piece && (
                    <div style={{ marginBottom: '3px' }}>
                      <strong>Peça:</strong>{' '}
                      {typeof imageItem.piece === 'object' &&
                      imageItem.piece !== null
                        ? imageItem.piece.label ||
                          String(imageItem.piece.value || '')
                        : String(imageItem.piece || '')}
                    </div>
                  )}
                  {imageItem.description && (
                    <div style={{ marginBottom: '3px' }}>
                      <strong>Descrição:</strong>{' '}
                      {typeof imageItem.description === 'object' &&
                      imageItem.description !== null
                        ? imageItem.description.label ||
                          String(imageItem.description.value || '')
                        : String(imageItem.description || '')}
                    </div>
                  )}
                  {imageItem.observation &&
                    typeof imageItem.observation === 'string' && (
                      <div style={{ marginBottom: '3px' }}>
                        <strong>Observação:</strong> {imageItem.observation}
                      </div>
                    )}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div
          className="os-term-report-section-services"
          style={{ paddingBottom: '16px' }}
        >
          <div className="os-term-report-section-header-report">
            <text className="os-term-report-section-title">
              TERMO PRESTAÇÃO DE SERVIÇO
            </text>
          </div>

          <div className="report-section">
            <div className="report-content">
              <div className="report-text">
                {props?.values?.authorizationTerm ||
                  props?.company?.authorizationTerm ||
                  '---'}
              </div>
            </div>
          </div>

          <div style={{ marginTop: '40px' }}>
            {/* Assinatura Digital */}
            {(props?.values?.client_signature ||
              props?.localSignatureData?.signature) && (
              <div style={{ marginBottom: '10px' }}>
                {(props?.localSignatureData?.date ||
                  props?.values?.signature_date) && (
                  <div
                    style={{
                      fontSize: '10px',
                      color: '#666',
                      marginTop: '4px',
                    }}
                  >
                    Assinado digitalmente em:{' '}
                    {props?.localSignatureData?.date
                      ? new Date(props.localSignatureData.date).toLocaleString(
                          'pt-BR'
                        )
                      : new Date(props.values.signature_date).toLocaleString(
                          'pt-BR'
                        )}
                  </div>
                )}
                <img
                  src={
                    props?.localSignatureData?.signature ||
                    props.values.client_signature
                  }
                  alt="Assinatura do cliente"
                  style={{
                    maxWidth: '300px',
                    height: 'auto',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    backgroundColor: 'white',
                    display: 'block',
                  }}
                />
              </div>
            )}

            <div className="os-term-report-signature">
              {clientFound?.label || '---'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
